import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { BrowserRouter, Routes, Route } from 'react-router';
import userManager from './auth/auth.ts';
import { login } from './auth/authService.ts';

const container = document.getElementById('app')!;

async function main() {
  const isCallback = window.location.pathname === '/callback';

  if (isCallback) {
    renderApp(null);
    return;
  }

  const user = await userManager.getUser();

  if (!user || user.expired) {
    await login();
    return;
  }

  renderApp(user);
}

function renderApp(user: any) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <Routes>
          <Route path='*' element={<App initialUser={user} />} />
        </Routes>
      </BrowserRouter>
    </React.StrictMode>
  );
}

main();
